<template>
  <div class="w-full mx-auto mt-8 flex flex-col px-20">
    <p class="text-center">Get access to more than 1500 ads + amazing tools</p>
    <div class="max-w-3xl w-full mx-auto mt-8 flex justify-center">
      <div
        v-show="role === 'free'"
        class="mx-4 mb-8 text-center py-4 px-4 grid content-between"
      >
        <div>
          <h3 class="text-3xl font-semibold text-gray-custom-h">
            Limited access
          </h3>
          <p class="text-base text-gray-custom-p">Billed Monthly</p>
          <div class="py-8">
            <span class="text-4xl text-gray-custom-h">$49</span>
            <span class="text-base text-gray-custom-p">/ month</span>
          </div>
          <ul class="text-base text-left">
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />
              <p>Access only to this month’s batch of ads</p>
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />New 100 ads
              from fast-growing eComm brands every month
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />Cancel Anytime
            </li>
          </ul>
          <button
            type="button"
            class="inline-flex justify-center mt-20 bg-indigo-600 w-full rounded-md border px-4 py-2 bg-white text-base leading-6 font-medium text-white shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="buyMonthly"
          >
            Full Access
          </button>
        </div>
      </div>
      <div
        v-show="role === 'default' || role === 'free'"
        class="mx-4 mb-8 text-center py-4 px-4 grid content-between"
      >
        <div class="mb-12">
          <h3 class="text-3xl font-semibold text-gray-custom-h">
            Unlimited access
          </h3>
          <p class="text-base text-gray-custom-p">Limited offer 50% OFF</p>
          <div class="py-8">
            <span class="text-4xl text-gray-custom-h">$̶5̶8̶8̶$297</span>
            <span class="text-base text-gray-custom-p">/ year</span>
          </div>
          <ul class="text-base text-left">
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />Access to the
              entire Adbox library of 1500+ ads
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />New 100 ads
              from fast-growing eComm brands every month
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />All future
              perks, and features
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />Regular price:
              $588/year Limited early adopter pricing
            </li>
            <li class="flex items-center mb-2">
              <Icon name="Check" class="flex-none mr-3 w-4 h-4" />Cancel Anytime
            </li>
          </ul>
          <button
            v-if="role === 'free'"
            type="button"
            class="inline-flex justify-center mt-4 bg-indigo-600 w-full rounded-md border px-4 py-2 bg-white text-base leading-6 font-medium text-white shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="buyAnnual"
          >
            Full Access
          </button>
          <button
            v-else
            type="button"
            :class="loading ? `bg-indigo-700` : `bg-indigo-600`"
            class="transition inline-flex justify-center mt-4 w-full rounded-md border px-4 py-2 bg-white text-base leading-6 font-medium text-white shadow-sm hover:text-gray-500 focus:outline-none focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="upgradeToAnnual"
          >
            <span v-show="!loading">Upgrade</span>
            <div v-show="loading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  setup() {
    const store = useStore();

    const loading = ref(false);

    const role = computed(() => store.state.role);

    const buyMonthly = () => {
      const plan_id = 589466;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const buyAnnual = () => {
      const plan_id = 636842;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const upgradeToAnnual = async () => {
      loading.value = true
      const { success, data } = await store.dispatch("UPGRADE_SUBSCRIPTION");
      loading.value = false;
      if (!success) {
        store.dispatch("alert/SHOW_ERROR", {
          message: data.data,
          duration: 5000
        })
      }
    };

    return { buyMonthly, buyAnnual, upgradeToAnnual, role, loading };
  },
};
</script>

<style>

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 9px;
  margin: 7.2px 0;
}
.lds-ellipsis div {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 24px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 42px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(18px, 0);
  }
}
</style>
